import { Theme } from '@mui/material/styles'

const muiButtonBase = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        '&.Mui-disabled': {
          cursor: 'not-allowed',
          transition: 'none',
          pointerEvents: 'auto'
        }
      }
    }
  }
}

export default muiButtonBase
